import { useState } from 'react';
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import HistoryIcon from '@mui/icons-material/HistoryOutlined';
import { format, parseISO } from 'date-fns';
import { getLastUsed } from './api';

type State =
  | { status: 'idle' }
  | { status: 'loading' }
  | { status: 'done'; date: string | null }
  | { status: 'error' };

export function LastUsedCell({ companyId, basePath }: { companyId: number; basePath: string }) {
  const [state, setState] = useState<State>({ status: 'idle' });

  async function load() {
    setState({ status: 'loading' });
    try {
      const res = await getLastUsed(companyId, basePath);
      setState({ status: 'done', date: res.lastUsedAt });
    } catch {
      setState({ status: 'error' });
    }
  }

  if (state.status === 'loading') return <CircularProgress size={16} />;

  if (state.status === 'done') {
    return (
      <Tooltip title="ໂຫຼດຄືນ">
        <Box component="span" onClick={() => void load()} sx={{ cursor: 'pointer' }}>
          {state.date ? format(parseISO(state.date), 'dd/MM/yyyy HH:mm') : '—'}
        </Box>
      </Tooltip>
    );
  }

  if (state.status === 'error') {
    return (
      <Tooltip title="ຜິດພາດ — ກົດເພື່ອລອງໃໝ່">
        <Box component="span" onClick={() => void load()} sx={{ cursor: 'pointer', color: 'text.secondary' }}>—</Box>
      </Tooltip>
    );
  }

  return (
    <Tooltip title="ກວດວັນທີໃຊ້ງານລ່າສຸດ">
      <IconButton size="small" onClick={() => void load()} aria-label={`last-used ${companyId}`}>
        <HistoryIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
